Page homePage
	needsAuth = false

	Good	good
	Field[]	alwaysFields = []
	Field[]	oneByOneFields = []
	int	visibleOneByOneCount = 0
	bool	videoPlaying = false
	ValidationState	validationState = {}
	bool	generalTermsAccepted = false

	show: string id = ""
		html.setTitle "Wohnmobil verkaufen - einfach, sicher und stressfrei" + app.titleSuffix
		reset

	reset
		if good == null then good = app.createDefaultGood Guest
		validationState.clear
		visibleOneByOneCount = 0
		videoPlaying = false

	updateFields
		alwaysFields.clear
		oneByOneFields.clear

		// Filter fields by showOnHomePage
		app.fields.sortBy.editOrder
		for app.fields as field
			if field.showFor.includes(good.Typ)
				if app.user and (field.fieldName == "EMail" or field.fieldName == "Telefon") then continue
				if field.showOnHomePage == Always
					alwaysFields.add field
					// Initialize field value
					if good[field.fieldName] == null
						good[field.fieldName] = ""
				else if field.showOnHomePage == OneByOne
					oneByOneFields.add field
					// Initialize field value
					if good[field.fieldName] == null
						good[field.fieldName] = ""

	Field[] getVisibleFields
		Field[] result = []
		for alwaysFields as field
			result.add field
		for visibleOneByOneCount as i
			if i < oneByOneFields.length
				result.add oneByOneFields[i]
		return result
			
	draw
		updateFields
		// html.style "@media (max-width: 959px)", "#home-top-section \{ flex-direction: column; \} #home-top-section > div \{ width: 100% !important; \}"
		div display:flex, flexDirection:column, alignItems:center, padding:{bottom:60}, gap:40
			drawTopSection
			drawFormSection
			div app.getText("features") marginTop:32
			div app.getText("faqPage") marginTop:32
			html.closeDetails

	drawTopSection
		column
			div app.getText("homePageTitle")
			if isMobile
				column gap:20
					drawVideo
					drawIntroText
			else
				grid width:100%, gap:40, gridTemplateColumns:"280fr 600fr"
					drawIntroText
					drawVideo

	drawIntroText
		div app.getText("homePageIntro")

	drawVideo
		let video = div tag:"video", width:100%, height:auto
			borderRadius:20, boxShadow:{offset:{10,10}, blur:30, spread:0, color:#909090}
			display:videoPlaying ? block : none
			data:{src:"intro640x360.mp4", controls:"true", loop:"true"}
		img VideoThumbnail, width:100%, height:auto
			borderRadius:20, boxShadow:{offset:{10,10}, blur:30, spread:0, color:#909090}
			cursor:pointer, display:videoPlaying ? none : block
			onClick:videoPlaying = true; refresh; video.play()

	drawFormSection
		app.box
			column alignItems:center
				div width:400px
					display:flex, flexDirection:column, gap:24
					div "Einfach Fahrzeugdaten eingeben (5 Minuten)", fontSize:18, fontWeight:bold, color:#2b3145
					let visibleFields = getVisibleFields
					for visibleFields as field
						form.drawField field, new Reference(container:good, key:field.fieldName), validationState, 
							onInput: value => onFieldInput(i, field.fieldName, value)
							onChange: value => onFieldChanged(i, field.fieldName, value)
					column
						if visibleOneByOneCount >= oneByOneFields.length
							div marginBottom:16px
								form.toggle model:generalTermsAccepted, label:app.getText("generalTerms"), required:true, validationState
						app.button text:app.getText("callToAction"), onClick:onSubmit

	onFieldInput: int fieldIndex, string fieldName, dynamic value
		if fieldIndex >= alwaysFields.length+visibleOneByOneCount-1 and visibleOneByOneCount < oneByOneFields.length
			visibleOneByOneCount++
			if oneByOneFields[visibleOneByOneCount-1].fieldName == "readyForPickupTime"
				visibleOneByOneCount++
			refresh

	onFieldChanged: int fieldIndex, string fieldName, dynamic value
		if !good.id
			if app.user then good.seller = app.user.id
			good.test = app.test
			await app.goods.add good
		else
			await app.goods.updateField good, fieldName, value

	onSubmit
		try
			if validationState.checkForErrorsOrEmptyFields then return
			if !good.id 
				if app.user then good.seller = app.user.id
				await app.goods.add good
			editPage.good = good
			good = null
			reset
			if app.user
				app.navigateTo editPage, editPage.good.id
			else
				app.navigateTo loginPage
		catch
			print type:Error "Error submitting good:", error
